import React from 'react';
import PropTypes from 'prop-types';
import { Helmet as ReactHelmet } from 'react-helmet';

class Helmet extends React.Component {
  static defaultProps = {
    title: '',
  }

  render() {
    const { title } = this.props;
    const siteTitle = title ? `${title} | Affiliate World Asia` : 'Affiliate Block Party';
    const description = 'Come and hang with 2,000 of the industry’s biggest affiliates for an evening of reuniting with old friends and making new ones. Expect secrets to be spilled as the cocktails flow.';
    const url = 'https://affiliateblockparty.com/';
    return (
      <ReactHelmet>
        <title>{siteTitle}</title>
        <meta name="title" content={siteTitle} />
        <meta name="description" content={description} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://cdn.istack.network/static/adworld-cms-production/meta_image_blockparty2_6f1003ba49/meta_image_blockparty2_6f1003ba49.jpg" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={url} />
        <meta property="twitter:title" content={siteTitle} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content="https://cdn.istack.network/static/adworld-cms-production/meta_image_blockparty2_6f1003ba49/meta_image_blockparty2_6f1003ba49.jpg" />
      </ReactHelmet>
    );
  }
}

Helmet.propTypes = {
  title: PropTypes.string,
};

export default Helmet;



// WEBPACK FOOTER //
// ./src/components/Helmet/index.js